import { Person } from '@/interfaces/person';
import { DriverService } from '@/services/driver/driver.service';
import { Option } from '@/shared/select-list/select-list.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { RequirementService } from '../../../../../../services/requirement/requirement.service';

@Component({
  selector: 'app-form-select-person-mine',
  templateUrl: './form-select-person.component.html',
  styleUrls: ['./form-select-person.component.css'],
})
export class FormSelectPersonComponent implements OnInit {

  @Input() controlForm: FormGroup = new FormGroup({
    id: new FormControl(0, [Validators.required, Validators.min(1)]),
    email: new FormControl('', [Validators.required]),
    mdmid: new FormControl('', [Validators.required]),
  });

  @Output() resetForm = new EventEmitter();

  personForm: FormGroup = new FormGroup({
    filterText: new FormControl(''),
    id: new FormControl(-1),
  });

  @Input() selectedPersonData?: Person;

  listPersonOptions: Option[] = [];
  loadingPersonOptions: boolean = false;

  constructor(
    private driverService: DriverService,
    private requirementService: RequirementService,
  ) {
    const {
      filterText: filterText$,
    } = this.personForm.controls;
    filterText$.valueChanges
      .pipe(
        tap(() => {
          this.loadingPersonOptions = true;
        }),
        debounceTime(2000),
        switchMap((value) => this.driverService.getActiveMineLicenseFilteredList(value)),
      )
      .subscribe({
        next: (options) => {
          this.listPersonOptions = options;
          this.loadingPersonOptions = false;
        },
      });
  }

  ngOnInit(): void {
    this.controlForm.controls.id.valueChanges.subscribe({
      next: (value) => {
        if (value === null) {
          this.selectedPersonData = undefined;
        }
      },
    });
  }
  onSearchPersonTextChange(text: string) {
    this.personForm.patchValue({ filterText: text });
  }

  onSearchPersonSelected(id: string) {
    this.personForm.patchValue({ id: +id });
  }
  onSelectPerson() {
    const personId = this.personForm.controls.id.value;
    this.driverService.getDataById(personId).subscribe({
      next: (personData) => {
        this.selectedPersonData = personData;
        this.controlForm.controls.id.patchValue(personId);
        this.controlForm.controls.email.patchValue(personData.email);
        this.controlForm.controls.mdmid.patchValue(personData.mdmid);
      },
    });
  }

  onUnselect() {
    this.personForm.patchValue({ id: -1, filterText: '' });
    this.selectedPersonData = undefined;
    this.listPersonOptions = [];
    this.controlForm.controls.id.patchValue(0);
    this.controlForm.controls.email.patchValue('');
    this.controlForm.controls.mdmid.patchValue('');
    this.resetForm.emit('');
  }

}
